import {
  FormErrorWithDiscriminatedField,
  FormSchema,
  StationCommunicationSystemsEnum,
} from "features/CenterContent/RoleContent/TrainMap/StretchBuilder/stationEvents/types/formSchema";
import { TFunction } from "i18next";
import { FC } from "react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import {
  ChoiceChip,
  Field,
  FieldErrorText,
  HStack,
} from "shared/components/Spor";

type CommunicationSystem = {
  value: StationCommunicationSystemsEnum;
  name: string;
};

const getCommunicationSystems = (
  translate: TFunction<"translation", undefined>,
): CommunicationSystem[] => [
  { value: "TRACK_MONITORS", name: translate("Anvisere") },
  { value: "SPEAKERS", name: translate("Høyttalere") },
  { value: "ARRIVAL_AND_DEPARTURE_MONITORS", name: translate("Monitorer") },
];

const updateAffectedSystems = (
  affectedSystems: StationCommunicationSystemsEnum[],
  system: StationCommunicationSystemsEnum,
): StationCommunicationSystemsEnum[] => {
  if (affectedSystems?.includes(system)) {
    return affectedSystems.filter((s) => s !== system);
  }
  return [...(affectedSystems ?? []), system];
};

export const StationCommunicationSystemsDown: FC = () => {
  const { t } = useTranslation();
  const { watch, setValue, clearErrors, formState } =
    useFormContext<FormSchema>();
  const affectedSystems = watch("stationForm.affectedSystems");
  const fieldErrors: FormErrorWithDiscriminatedField<"affectedSystems"> =
    formState.errors.stationForm;

  return (
    <>
      <Field as="legend">{t("Velg påvirkede systemer")}</Field>

      <HStack flexWrap="wrap">
        {getCommunicationSystems(t).map((system) => (
          <ChoiceChip
            key={system.value}
            checked={affectedSystems?.includes(system.value)}
            onCheckedChange={() => {
              setValue(
                "stationForm.affectedSystems",
                updateAffectedSystems(affectedSystems, system.value),
              );
              clearErrors("stationForm.affectedSystems");
            }}
          >
            {system.name}
          </ChoiceChip>
        ))}
      </HStack>
      <Field as="fieldset" invalid={!!fieldErrors?.affectedSystems}>
        <FieldErrorText marginTop="12px">
          {fieldErrors?.affectedSystems?.message}
        </FieldErrorText>
      </Field>
    </>
  );
};
